import PropTypes from 'prop-types';
import { BsImage } from 'react-icons/bs';
import { Container, Image, PlaceholderImage } from './table-row-logo.styles';

/**
 * Component that renders a logo with an optional label.
 * @param {object} props The component props.
 * @param {string} props.width The width of the logo.
 * @param {string} props.margin The margin of the logo.
 * @param {string} props.src The source of the logo.
 * @returns {JSX.Element} The rendered TableRowLogo component.
 */
const TableRowLogo = ({ width, margin, src }) => (
  <Container width={width} margin={margin}>
    {src ? <Image src={src} /> : <PlaceholderImage src={<BsImage />} />}
  </Container>
);

TableRowLogo.defaultProps = {
  width: '',
  margin: '',
  src: '',
};

TableRowLogo.propTypes = {
  width: PropTypes.string,
  margin: PropTypes.string,
  src: PropTypes.string,
};

export default TableRowLogo;
